/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import { Grid, Typography, TextField, InputAdornment } from "@material-ui/core";
import Switch from "../../Shared/SwitchComponent";
import { PrimaryButton } from "../../Shared/Buttons";
import ModalComp from "../../Shared/ModalComp";
import { Check } from "@material-ui/icons";
import SuccessModal from "./SuccesModal";
import { makeStyles } from "@material-ui/styles";

const useStyles = makeStyles((theme) => ({
  customWidth: {
    width: "100%",
  },
  textstyle: {
    marginBottom: 5,
  },
}));
const AddRestaurantComp = ({
  classes,
  open,
  handleAddRestaurant,
  handleSaveModalClose,
  handleTextChange,
  handleSwitchChange,
  errors,
  restaurantData,
  uuid,
}) => {
  console.log("rest data>>>", restaurantData);
  const styles = useStyles();
  const [show, setShow] = useState(false);
  const buttonDisable =
    restaurantData.name.trim().length === 0 ||
    restaurantData.slug.trim().length === 0 ||
    restaurantData.email_id.trim().length === 0 ||
    errors.email_id;
  return (
    <>
      <div>
        <div className={(styles.customWidth, classes.mt20)}>
          <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
            Restaurant Name*
          </Typography>
        </div>
        <div className={styles.customWidth}>
          <TextField
            variant="outlined"
            fullWidth
            color="primary"
            size="small"
            className={classes.textFieldStyles}
            name="name"
            value={restaurantData.name}
            onChange={handleTextChange}
            error={errors.name}
            helperText={errors.name && "Invalid Restaurant Name!"}
            inputProps={{
              "aria-label": "restNameInput",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!errors.name && restaurantData.name && <Check />}
                </InputAdornment>
              ),
            }}
          />
        </div>

        <div className={(styles.customWidth, classes.mt20)}>
          <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
            Restaurant slug / subdomain*
          </Typography>
        </div>
        <Grid item xs={false} sm={8} md={9} />
        <div className={styles.customWidth}>
          <TextField
            variant="outlined"
            fullWidth
            color="primary"
            size="small"
            className={classes.textFieldStyles}
            name="slug"
            value={restaurantData.slug}
            onChange={handleTextChange}
            error={errors.slug}
            helperText={errors.slug && "Invalid Slug!"}
            inputProps={{
              "aria-label": "slugInput",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!errors.slug && restaurantData.slug && <Check />}
                </InputAdornment>
              ),
            }}
          />
        </div>
        <div className={(styles.customWidth, classes.mt20)}>
          <Typography variant="h6" color="primary" style={{ fontWeight: 600 }}>
            E-mail*
          </Typography>
        </div>
        <div className={styles.customWidth}>
          <TextField
            variant="outlined"
            fullWidth
            color="primary"
            size="small"
            className={classes.textFieldStyles}
            error={errors.email_id}
            name="email_id"
            value={restaurantData.email_id}
            onChange={handleTextChange}
            helperText={errors.email_id && "Invalid Email!"}
            inputProps={{
              "aria-label": "emailInput",
            }}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  {!errors.email_id && restaurantData.email_id && <Check />}
                </InputAdornment>
              ),
            }}
          />
        </div>

        <Grid container spacing={3} direction="row">
          <Grid item md={6} xs={6} sm={6}>
            <Grid item xs={6} sm={4} md={3} className={classes.mt20}>
              <Typography
                variant="h6"
                color="primary"
                style={{ fontWeight: 600 }}
              >
                Services*
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={8} className={classes.mt20}>
              <Grid container direction="row" justify="space-between">
                <Grid item xs={8} sm={8} md={8}>
                  <Typography variant="body1" color="primary">
                    Delivery
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={1} md={1}>
                  <Switch
                    labelText={`service_type_delivery`}
                    checked={restaurantData.service_type.delivery}
                    handleClick={(event) =>
                      handleSwitchChange(event, "delivery")
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={false} sm={8} md={9} />
            <Grid item xs={12} sm={8} md={8} className={classes.mt20}>
              <Grid container direction="row" justify="space-between">
                <Grid item xs={8} sm={8} md={8}>
                  <Typography variant="body1" color="primary">
                    Pickup
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={1} md={1}>
                  <Switch
                    labelText={`service_type_pickup`}
                    checked={restaurantData.service_type.pickup}
                    handleClick={(event) => handleSwitchChange(event, "pickup")}
                  />
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={8} md={8} className={classes.mt20}>
              <Grid container direction="row" justify="space-between"></Grid>
            </Grid>
          </Grid>
          <Grid item md={6} xs={6} sm={6}>
            <Grid item xs={6} sm={4} md={3} className={classes.mt20}>
              <Typography
                variant="h6"
                color="primary"
                style={{ fontWeight: 600 }}
              >
                Features*
              </Typography>
            </Grid>
            <Grid item xs={12} sm={8} md={8} className={classes.mt20}>
              <Grid container direction="row" justify="space-between">
                <Grid item xs={8} sm={8} md={8}>
                  <Typography variant="body1" color="primary">
                    Pay by Cash
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={1} md={1}>
                  <Switch
                    labelText={`feature_cash`}
                    checked={restaurantData.payment_types.pay_by_cash}
                    handleClick={(event) =>
                      handleSwitchChange(event, "pay_by_cash")
                    }
                  />
                </Grid>
              </Grid>
            </Grid>

            <Grid item xs={false} sm={8} md={9} />
            <Grid item xs={12} sm={8} md={8} className={classes.mt20}>
              <Grid container direction="row" justify="space-between">
                <Grid item xs={8} sm={8} md={8}>
                  <Typography variant="body1" color="primary">
                    Pay by Card
                  </Typography>
                </Grid>
                <Grid item xs={4} sm={1} md={1}>
                  <Switch
                    labelText={`feature_card`}
                    checked={restaurantData.payment_types.pay_by_card}
                    handleClick={(event) =>
                      handleSwitchChange(event, "pay_by_card")
                    }
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Grid item xs={false} sm={8} md={9} />
        <Grid item xs={12} sm={12} md={12} className={classes.mt20}>
          <PrimaryButton
            type="success"
            fullWidth={true}
            handleClick={handleAddRestaurant}
            disabled={buttonDisable}
            testId={`add_rest_btn`}
          >
            Add Restaurant
          </PrimaryButton>
        </Grid>
        {open && (
          <ModalComp
            open={open}
            handleClose={handleSaveModalClose}
            top={200}
            topMobile={200}
            width={500}
          >
            <SuccessModal
              classes={classes}
              handleSaveModalClose={handleSaveModalClose}
              restName={restaurantData.name}
              email={restaurantData.email_id}
              apikey={restaurantData.apikey}
              restId={uuid}
            />
          </ModalComp>
        )}
      </div>
    </>
  );
};

export default AddRestaurantComp;
